function DiseaseType() {
  return (
    <div>
      <li className="bullet-item">
        The DISGENET disease type: <b>disease</b>, <b>phenotype</b> and <b>group</b>.
      </li>
    </div>
  );
}

export default DiseaseType;
